/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Registration Utilities - Shared helpers for registration flows
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import toast from 'react-hot-toast'

// Basic email format validation regex
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Handle registration result with email verification check
 * @param {Object} result - Registration result from authStore
 * @param {string} email - User's email address
 * @param {Function} navigate - React Router navigate function
 * @returns {boolean} - True if email verification required (caller should return early)
 */
export const handleEmailVerificationRequired = (result, email, navigate) => {
  if (result.requiresEmailVerification) {
    // Email validation - check for valid email format
    if (!email || typeof email !== 'string' || !EMAIL_REGEX.test(email)) {
      toast.error('Invalid email address. Please try again.')
      navigate('/login')
      return true
    }
    toast.success('Account created! Please verify your email.')
    navigate('/verify-email', {
      state: {
        email,
        justRegistered: true
      }
    })
    return true
  }
  return false
}
